export default __webpack_public_path__ + "img/537268bc2b3653e59a26f04e6ae7592d.png";